// helpers
import { flattenPayload } from "@utils/object-helpers";
import { getJWT } from "@utils/browser-helpers";
import { isPlainObject } from "@utils/object-helpers";
import has from "lodash/has";
// constants
import { REWARDS_MFE_ATHOS } from "@constants/schema-management";

export const generateAthosConfig = (schemaParam) => {
  let defaultConfig = {};
  let schemaTopLevel = schemaParam.properties;
  const { schema_management_client } = getJWT();
  for (let key in schemaTopLevel) {
    schema_management_client === REWARDS_MFE_ATHOS
      ? (defaultConfig[key] = flattenPayload(
          setDefaults(schemaTopLevel[key].allOf, schemaParam.$defs)
        ))
      : (defaultConfig[key] = setDefaults(
          schemaTopLevel[key].properties,
          schemaParam.$defs
        ));
  }
  return defaultConfig;
};

export function setDefaults(objToIter, definitions) {
  return Object.keys(objToIter).reduce((acc, cur) => {
    if (objToIter[cur].type === "array") {
      acc[cur] = [];
    } else if (objToIter[cur].hasOwnProperty("properties")) {
      acc[cur] = setDefaults(objToIter[cur].properties, definitions);
    } else if (objToIter[cur].hasOwnProperty("allOf")) {
      acc[cur] = flattenPayload(setDefaults(objToIter[cur].allOf, definitions));
    } else if (objToIter[cur].hasOwnProperty("default")) {
      let currentObj = objToIter[cur].default;
      acc[cur] = currentObj;
    } else if (objToIter[cur].hasOwnProperty("$ref") && definitions) {
      let def = objToIter[cur].$ref.split("/");
      def = def[def.length - 1];
      acc[cur] = definitions[def].hasOwnProperty("properties")
        ? setDefaults(definitions[def].properties, definitions)
        : !objToIter[cur].hasOwnProperty("default")
        ? ""
        : {};
    } else {
      acc[cur] = null;
    }
    return acc;
  }, {});
}

export const compareAthosConfigs = (defaultConfig, loadedConfig) => {
  function findDeletedKeys(property, defaultObj, obj, path) {
    for (const key in defaultObj) {
      const newPath = path ? `${path}.${key}` : key;
      if (has(obj, key) && typeof defaultObj[key] === "object" && obj[key] !== null) {
          findDeletedKeys(property, defaultObj[key], obj[key], newPath);
      } else if (isPlainObject(defaultObj[key])) {
        deletedKeys[property].push(`${property}.${newPath}`);
      }
    }
  }
  const deletedKeys = {};
  for (const property in loadedConfig) {
    deletedKeys[property] = [];
    findDeletedKeys(
      property,
      defaultConfig[Object.keys(defaultConfig)[0]],
      loadedConfig[property],
      ""
    );
  }
  return deletedKeys;
};
